import { AxiosResponse } from "axios";
import {
  ProgramEntity,
  ProgramEntityInput,
  ProgramReadingItem,
} from "./programs.types";
import { api } from "../api";

export const getProgramsByCourse = async (courseId: number): Promise<ProgramEntity[]> => {
  try {
    const response: AxiosResponse<ProgramEntity[]> = await api.get(`/programs/by-course/${courseId}`);
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getPrograms = async () => {
  try {
    const response: AxiosResponse<ProgramEntity[]> = await api.get("/programs");
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getProgramById = async (id: number) => {
  try {
    const response: AxiosResponse<ProgramEntity> = await api.get(
      "/programs/" + id
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createProgram = async (data: ProgramEntityInput) => {
  try {
    const response: AxiosResponse<ProgramEntity> = await api.post(
      "/programs",
      data
    );

    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateProgram = async (id: number, data: ProgramEntityInput) => {
  try {
    const response: AxiosResponse<ProgramEntity> = await api.patch(
      "/programs/" + id,
      data
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const deleteProgram = async (id: number) => {
  try {
    const response: AxiosResponse<ProgramEntity> = await api.delete(
      "/programs/" + id
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

// ─── Lecturas vinculadas a un programa (Comprensión Lectora) ──────────────────

/** Lista las lecturas vinculadas a un programa (sin filtros). */
export const getProgramReadings = async (
  programId: number
): Promise<ProgramReadingItem[]> => {
  try {
    const response: AxiosResponse<ProgramReadingItem[]> = await api.get(
      `/reading-content/by-program/${programId}`
    );
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    return [];
  }
};

/** Asocia un recurso de lectura a un programa. */
export const addResourceToProgram = async (
  programId: number,
  resourceId: number,
  orderBy?: number
) => {
  try {
    const response = await api.post(
      `/reading-content/by-program/${programId}/resources`,
      { resource_id: resourceId, order_by: orderBy }
    );
    return response.status >= 200 && response.status < 300
      ? response.data
      : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

/** Desasocia (soft-delete) un recurso de lectura de un programa. */
export const removeResourceFromProgram = async (
  programId: number,
  resourceId: number
) => {
  try {
    const response = await api.delete(
      `/reading-content/by-program/${programId}/resources/${resourceId}`
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
